export const INITIAL_STATE={hours:null,minutes:null};